const CUSTOM_VENDORS_ENCODING_VERSION = 1

export const encodeCustomVendorsConsents = customVendorsConsents => {
  const packed = Object.entries(customVendorsConsents)
    .map(([id, { consent }]) => [parseInt(id), consent])
    .reduce((acc, [id, consent]) => {
      (acc[consent] = acc[consent] || []).push(id)
      return acc
    }, {})
  return JSON.stringify({
    v: CUSTOM_VENDORS_ENCODING_VERSION,
    packed
  })
}

export const decodeCustomVendorsConsents = encoded => {
  const parsed = JSON.parse(encoded)
  const { v } = parsed
  if (v > CUSTOM_VENDORS_ENCODING_VERSION) {
    throw new Error(`Cannot decode version "${v}, highest known is "${CUSTOM_VENDORS_ENCODING_VERSION}"`)
  }
  const { packed } = parsed
  return Object.entries(packed)
    .reduce((acc, [consent, ids]) => {
      return ids.reduce((acc, id) => ({
        ...acc,
        [id]: { consent: consent === 'true' }
      }), acc)
    }, {})
}
